import type { IAllDropdownConfig, IAllQueryVariablesMapper } from "./config";

export const dropdownParamMapper: IAllQueryVariablesMapper = {
  city: (params) => ({
    optionType: "city",
    params: { state_id: params.state_id },
  }),
  country: (params) => ({
    optionType: "country",
    queryParam: params,
    params: {},
  }),
  countryTimezone: (params) => ({
    optionType: "countryTimezone",
    params: { country_id: params.country_id },
  }),
  dosage: (params) => ({
    optionType: "dosage",
    params: { medicineName: params.medicineName },
  }),
  medicineFormulation: (params) => ({
    optionType: "medicineFormulation",
    params: {
      medicineDosage: params.medicineDosage,
      medicineName: params.medicineName,
    },
  }),
  medicineName: (_params) => ({
    optionType: "medicineName",
    params: {},
  }),
  medicineType: (_params) => ({
    optionType: "medicineType",
    params: {},
  }),
  messagingUsersList: (params) => ({
    optionType: "messagingUsersList",
    params: {},
    queryParam: { role_name: params.role_name },
  }),
  reuseInterval: (_params) => ({
    optionType: "reuseInterval",
    params: {},
  }),
  speciality: (_params) => ({
    optionType: "speciality",
    params: {},
  }),
  state: (params) => ({
    optionType: "state",
    params: { country_id: params.country_id },
  }),
  subSpeciality: (params) => ({
    optionType: "subSpeciality",
    params: { parent_speciality_id: params.parent_speciality_id },
  }),
  timezone: (_params) => ({
    optionType: "timezone",
    params: {},
  }),
  usageAmount: (_params) => ({
    optionType: "usageAmount",
    params: {},
  }),
  usageApproach: (_params) => ({
    optionType: "usageApproach",
    params: {},
  }),
  usageDuration: (_params) => ({
    optionType: "usageDuration",
    params: {},
  }),
  userName: (params) => ({
    optionType: "userName",
    params: { role: params.role },
  }),
  visitHistories: (params) => ({
    optionType: "visitHistories",
    params: { summaryNoteId: params.summaryNoteId, type: params.patternType },
  }),
};

export const dropdownConfig: IAllDropdownConfig = {
  city: {
    hookOptions: (variables) => ({
      enabled: !!variables.state_id,
    }),
  },
  country: {},
  countryTimezone: {
    hookOptions: (variables) => ({
      enabled: !!variables.country_id,
    }),
  },
  dosage: {
    hookOptions: (variables) => ({
      enabled: !!variables.medicineName,
    }),
  },
  medicineFormulation: {
    hookOptions: (variables) => ({
      enabled: !!variables.medicineDosage && !!variables.medicineName,
    }),
  },
  medicineType: {},
  medicineName: {},
  messagingUsersList: {
    hookOptions: (variables) => ({
      enabled: !!variables.role_name,
    }),
  },
  reuseInterval: {},
  speciality: {},
  state: {
    hookOptions: (variables) => ({
      enabled: !!variables.country_id,
    }),
  },
  subSpeciality: {
    hookOptions: (variables) => ({
      enabled: !!variables.parent_speciality_id,
    }),
  },
  timezone: {},
  usageAmount: {},
  usageApproach: {},
  usageDuration: {},
  userName: {
    hookOptions: (variables) => ({
      enabled: !!variables.role,
    }),
  },
  visitHistories: {
    hookOptions: (variables) => ({
      enabled: !!variables.patternType && !!variables.summaryNoteId,
    }),
  },
};
